<template>
	<section class="content">
		<div class="flex justify-content-center">
			<div class="w-100">
			<!-- Baris Filter Utama -->
			<div class="row mb-4 align-items-center" style="row-gap: .5rem;" v-if="role != 9">
				<div class="col-12 col-md-auto d-flex align-items-center">
					<span class="font-weight-bold text-secondary mr-3 text-sm" style="white-space: nowrap;">Pilih Kurir</span>
					<!-- Input Cari Kota / Provinsi -->
					<div class="input-group mr-2" style="max-width: 250px;" v-if="false">
						<input type="text" v-model="filter.keyword" @keyup.enter="showTable" class="form-control text-sm" placeholder="Cari kota / provinsi..." />
					</div>
					<!-- Dropdown Pilih Kurir -->
					<select v-model="filter.courier_filter" @change="showTable" class="form-control text-sm mr-2" style="max-width: 150px; font-weight: 600;">
						<option v-for="item in courierList" :key="item.id" :value="item.id">
							{{ item.prefix }}
						</option>
					</select>
					<!-- Hasil Filter Text -->
					<span class="text-muted text-xs" v-if="summary.total_rows">{{ summary.total_rows }} hasil</span>
				</div>
			</div>

			<!-- Widget Ringkasan / Info Box -->
			<div class="row 4">
				<div class="col-12 col-sm-6 col-md-3" v-if="role != 9">
					<div class="info-box">

						<div class="info-box-content">
							<h5 class="info-box-text text-sm">KURIR AKTIF</h5>
							<h5 class="info-box-number">{{ summary.total_courier }}</h5>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3">
					<div class="info-box">

						<div class="info-box-content">
							<h5 class="info-box-text text-sm">TOTAL ORDER 2 BULAN</h5>
							<h5 class="info-box-number">{{ summary.total_order }}</h5>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3">
					<div class="info-box">

						<div class="info-box-content">
							<h5 class="info-box-text text-sm">AVG RATING KOTA</h5>
							<h5 class="info-box-number">{{ summary.avg_rating }}</h5>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3" v-if="role != 9">
					<div class="info-box">

						<div class="info-box-content">
							<h5 class="info-box-text text-sm">KURIR TERBAIK</h5>
							<h5 class="info-box-number">{{ summary.kurir_terbaik }}</h5>
						</div>
					</div>
				</div>
			</div>

			<!-- Area Konten Utama Datatable -->
			<div class="card border-0 shadow-sm rounded-lg">
				<div class="card-header bg-white py-3 border-0" v-if="role != 9">
					<h6 class="m-0 font-weight-bold text-secondary text-sm">Detail Rating Kurir — {{ activeCourierName }}</h6>
				</div>
				<div class="card-body">
					<div class="table-responsive" :hidden="hideTable">
						<table class="table table-hover border-bottom w-100 text-sm" ref="tableRatingKurir" id="tableRatingKurir">
							<thead>
								<tr class="text-muted text-uppercase font-weight-bold" style="font-size: 11px;">
									<th style="width: 5%">No</th>
									<th>Kota</th>
									<th>Provinsi</th>
									<th>Total&nbsp;Order</th>
									<th>Terkirim</th>
									<th>Retur</th>
									<th style="width: 15%">%&nbsp;Terkirim</th>
									<th style="width: 12%">%&nbsp;Retur</th>
									<th style="width: 12%">%&nbsp;Proses</th>
									<th class="text-center" style="width: 8%">Rating</th>
								</tr>
							</thead>
							<tbody></tbody>
						</table>
					</div>
				</div>
			</div>
			</div>
		</div>
	</section>
</template>
<script>
import { auth, authFetch, createTable } from "@/libs/hxcore";
import $ from "jquery";

export default {
	name: "RatingKurirDashboard",
	data() {
		return {
			loading: false,
			hideTable: true,
			dataTable: null,
			role: auth.user().role_id,
			courierList: [],
			filter: {
				keyword: null,
				courier_filter: null, 
			},
			summary: {
				total_courier: 0,
				total_order: 0,
				avg_rating: "0.00",
				kurir_terbaik: "-",
				total_rows: 0
			}
		};
	},
	computed: {
		activeCourierName() {
			const found = this.courierList.find(c => c.id === this.filter.courier_filter);
			return found ? found.prefix : null;
		}
	},
	methods: {
		loadBestCourierGlobal() {
			authFetch("/order/best_courier")
				.then(res => res.json())
				.then(res => {
					if (res.success) {
						this.summary.total_rows    = res.total_rows;
						this.summary.total_courier = res.total_courier;
						this.summary.total_order   = res.total_order;
						this.summary.avg_rating    = res.avg_rating;
						this.summary.kurir_terbaik = res.kurir_terbaik;
					}
				})
				.catch(err => {
					console.error("Gagal memuat statistik kurir terbaik:", err);
				});
		},
		showTable() {
			if (this.dataTable) {
				this.dataTable.api().ajax.reload();
			} else {
				var self = this;
				this.dataTable = createTable(this.$refs.tableRatingKurir, {
					roles: this.$route.params.roles,
					ajax: "/order/rating_courier",
					filterBy: [1, 2],
					frame: false,
					scrollCollapse: true,
					scrollX: true,
					processing: true,
					autoWidth: false,
					order: [[1, "asc"]], 
					paramData: function (d) {
						d.keyword = self.filter.keyword;
						d.courier_filter = self.filter.courier_filter;
					},
					columns: [
						{
							data: null,
							sortable: false,
							render: function (data, type, row, meta) {
								return meta.row + meta.settings._iDisplayStart + 1;
							}
						},
						{ 
							data: "kota",
							render: function (data) {
								return `<span class="font-weight-bold text-dark">${data}</span>`;
							}
						},
						{ data: "provinsi" },
						{ data: "count_order" },
						{ data: "count_delivered" },
						{ 
							data: "count_retur",
							render: function(data) {
								return parseInt(data) > 0 ? `<span class="text-danger">${data}</span>` : `<span class="text-muted">${data}</span>`;
							}
						},
						{ 
							data: "delivered_percen",
							render: function (data) { 
								return `<div class="d-flex align-items-center">
									<div class="progress mr-2 w-100" style="height: 6px; border-radius:4px;">
										<div class="progress-bar bg-success" role="progressbar" style="width: ${data}%"></div>
									</div>
									<span class="text-muted text-xs font-weight-bold" style="min-width:45px; text-align:right;">${data}%</span>
								</div>`;
							}
						},
						{ 
							data: "retur_percen",
							render: function (data) { 
								return `<div class="d-flex align-items-center">
									<div class="progress mr-2 w-100" style="height: 6px; border-radius:4px;">
										<div class="progress-bar bg-danger" role="progressbar" style="width: ${data}%; background-color:#eaeaea;"></div>
									</div>
									<span class="text-muted text-xs" style="min-width:45px; text-align:right;">${data}%</span>
								</div>`;
							}
						},
						{ 
							data: "proses_percen",
							render: function (data) { 
								return `<div class="d-flex align-items-center">
									<div class="progress mr-2 w-100" style="height: 6px; border-radius:4px;">
										<div class="progress-bar bg-warning" role="progressbar" style="width: ${data}%; background-color:#eaeaea;"></div>
									</div>
									<span class="text-muted text-xs" style="min-width:45px; text-align:right;">${data}%</span>
								</div>`;
							}
						},
						{ 
							data: "rating",
							render: function (data) {
								var val = parseFloat(data).toFixed(2);
								var txtColor = "text-success";
								if (val < 4.0) txtColor = "text-danger";
								else if (val < 4.5) txtColor = "text-warning";

								return `<div class="text-center font-weight-bold ${txtColor} bg-light py-1 px-2 rounded" style="font-size:12px; font-family: monospace;">${val}</div>`;
							}
						}
					],
					initComplete: function(settings, json) {
						self.hideTable = false;
						$('.loading-overlay').removeClass('show');
					}
				});
			}
		}
	},
	mounted() {
		this.loadBestCourierGlobal();

		if (this.role != 9) {
			authFetch("/order/courier_list_active")
				.then(res => res.json())
				.then(js => {
					if (js && js.data && js.data.length > 0) {
						this.courierList = js.data;
						this.filter.courier_filter = js.data[0].id;
						this.showTable();
					}
				});
		} else {
			this.showTable();
		}
	}
};
</script>